/**
 * Stub for Court endpoints.
 */
export interface IDocumentsEndpoints {
  getDocumentHistory: (documentId: number) => string;  
}

/**
 * Courts endpoints
 * @param versionedUrl
 */
export const documentsEndpoints = (versionedUrl: string): IDocumentsEndpoints => {
  const baseUrl = `${versionedUrl}documents`;

  return {
    getDocumentHistory: (documentId: number) => `${baseUrl}/documentid/${documentId}/history`    
  }
}
